import type { AppThunk } from 'state';
import type { DataCountry } from 'common/dataService/types/countriesTypes';
import FetchingStatus from 'constants/statuses/FetchingStatus';
import fetchDataCountries from './fetchDataCountries';
import getDataCountries from '../selectors/getDataCountries';

function loadDataCountries(): AppThunk<DataCountry[] | []> {
  return async function loadDataCountriesThunk(dispatch, getState) {
    try {
      let state = getState();
      let dataCountries = getDataCountries(state);
      const { fetching } = state.dataService.dataCountries;

      if (fetching === FetchingStatus.Succeeded) {
        return dataCountries;
      }

      await dispatch(fetchDataCountries());

      state = getState();
      dataCountries = getDataCountries(getState());

      if (state.dataService.dataCountries.fetching === FetchingStatus.Succeeded) {
        return dataCountries;
      }
    } catch (error) {
      window.Rollbar.error(error as Error);
    }

    return [];
  };
}

export default loadDataCountries;
